import type { InputHTMLAttributes, SelectHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

const FIELD =
  "h-8 rounded-control border border-border bg-surface px-2.5 text-[12px] shadow-sm " +
  "text-ink placeholder:text-muted-2 transition-colors " +
  "hover:border-muted-2 focus:border-accent";

export function Input({
  className,
  ...rest
}: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...rest} className={cn(FIELD, className)} />;
}

export function Select({
  className,
  children,
  ...rest
}: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select {...rest} className={cn(FIELD, "pr-6", className)}>
      {children}
    </select>
  );
}
